import { ApiBase } from '../api.js';
import {
	LicensorParameters,
	LicensorWithBrands
} from '../types/api/licensors.js';

export class ApiLicensor extends ApiBase {
	async create(data: unknown): Promise<unknown> {
		const result = await this.api.post('/licensors', data);
		return result.data;
	}

	async dashboardCreate(data: unknown): Promise<unknown> {
		const result = await this.api.post('/licensors/dashboard-create', data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}

	async read(data): Promise<unknown> {
		const result = await this.api.get('/licensors', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async readForDA(data: LicensorParameters): Promise<any> {
		const result = await this.api.get('/licensors/admin', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async getUserLicensor(): Promise<unknown> {
		const result = await this.api.get('/licensors/get-licensor', {});
		return result.data;
	}

	async update(data: unknown): Promise<unknown> {
		const result = await this.api.put('/licensors', data);
		return result.data;
	}

	async updateShutdownCheckerTier(data: { id: string, shutdown_checker_tier: number | null; }): Promise<unknown> {
		const result = await this.api.put(`/licensors/${ data.id }/shutdown-checker-tier`, data);
		return result.data;
	}

	async dashboardClientUpdate(data: unknown): Promise<unknown> {
		console.log('data sending: ', data);
		const result = await this.api.put(`/licensors/dashboard-client`, data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}

	async delete(data: unknown): Promise<unknown> {
		const result = await this.api.delete('/licensors', data);
		return result.data;
	}

	async getMissingTscListings(licensorId: string, marketplaceId?: string): Promise<unknown> {
		console.log('WE ARE GETTING IN QUERRYYYY', marketplaceId);
		const result = await this.api.get(`/licensors/${ licensorId }/listings/missing-tsc`, {
			params: {
				...(marketplaceId ? { marketplace_id: marketplaceId } : {})
			}
		});
		return result.data;
	}

	async readOne(licensorId: string): Promise<unknown> {
		const result = await this.api.get(`/licensors/${ licensorId }`, {});
		return result.data;
	}

	async getActiveLicensors(): Promise<any> {
		const result = await this.api.get('/licensors/active');
		return result.data;
	}

	async getSpellcheckRestrictions(): Promise<{ forbidden_words: string; }> {
		const result = await this.api.get(`/licensors/spellcheck-restrictions`);
		return result.data;
	}

	async updateSpellcheckRestrictions(data: {
		forbidden_words: string;
	}): Promise<{ message: string; }> {
		const result = await this.api.put(`/licensors/spellcheck-restrictions`, data);
		return result.data;
	}

	async getActiveLicensorsWithBrands(): Promise<LicensorWithBrands[]> {
		const result = await this.api.get('/licensors/active-with-brands');
		return result.data;
	}

	async licensorMarketplaceRead(data: LicensorParameters) {
		const result = await this.api.get('/licensors/licensor-marketplaces', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async readMarketplaceOne(data: any): Promise<unknown> {
		const result = await this.api.get(`/licensors/${ data.licensor_id }`, {
			params: {
				...data
			}
		});
		return result.data;
	}

	async addLicensorMarketplace(data: {
		licensor_id: string;
		marketplace_id: string;
	}): Promise<unknown> {
		const result = await this.api.post(
			`/licensors/${ data.licensor_id }/marketplace/${ data.marketplace_id }`,
			{}
		);
		return result.data;
	}

	async removeLicensorMarketplace(data: {
		licensor_id: string;
		marketplace_id: string;
	}): Promise<unknown> {
		const result = await this.api.delete(
			`/licensors/${ data.licensor_id }/marketplace/${ data.marketplace_id }`,
			{}
		);
		return result.data;
	}

	async modifyAllMarketplace(data: {
		licensor_id: string;
		isEnable: boolean;
	}): Promise<{ success: boolean; }> {
		const result = await this.api.post(
			`/licensors/${ data.licensor_id }/all-marketplace/${ data.isEnable }`,
			{}
		);
		return result.data;
	}

	async modifyLicensorStatus(data: { id: string; status: boolean; }): Promise<{ success: boolean; }> {
		const result = await this.api.get(
			`/licensors/${ data.id }/licensor-status/${ data.status }
`,
			{}
		);
		return result.data;
	}
}
